































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Header extends Vue {
  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get userName(): string {
    const user = this.$store.state.adminMe.user;
    if (!user) {
      return '';
    } else {
      return `${user.lastName}　${user.firstName}`;
    }
  }

  get myPageTitle(): string {
    const user = this.$store.state.adminMe.user;
    if (!user) {
      return '';
    } else {
      return `${user.lastName} ${user.firstName} さんの情報`;
    }
  }

  private mounted() {
    this.loadData();
  }

  private loadData() {
    this.$store.dispatch('adminMe/fetchMyData');
  }

  private operate(command: string) {
      this.$router.push(command);
  }

  private onClickMenu() {
    this.$emit('clickMenu');
  }
}
